import store from '@/store'
import { AUTH_TYPES } from '@/store/modules/auth'
import { storeItem } from '@/utils/local-storage'
import { isAuthenticated } from '@/utils/auth'
import { session } from '@/plugins/session-data'

export const requiresAuth = async (to, from, next, chained = false) => {
  if (!store.getters[AUTH_TYPES.getters.isAuthenticated]) {
    storeItem('redirect_on_callback', to.fullPath)
    await store.dispatch(AUTH_TYPES.actions.b2cSignIn)
    return false
  } else {
    return session(false)
      .then(() => {
        return (!chained)
          ? next()
          : true
      })
  }
}

export const requiresAnon = (to, from, next) => {
  if (!isAuthenticated()) {
    next()
  } else {
    next({
      path: '/overview'
    })
  }
}

export const requiresPermission = async (to, from, next) => {
  const authenticated = await requiresAuth(to, from, next, true)
  if (!authenticated) { return false }
  let unauthorized = true
  to.meta.permissions.forEach(routePermission => {
    if (store.state.auth.userPermissions.find(p => p.name === routePermission)) {
      unauthorized = false
    }
  })
  if (unauthorized) {
    next({
      path: '/auth/unauthorized'
    })
  } else {
    next()
  }
}

export const requiresError = async (to, from, next) => {
  if (store && store.state && store.state.error && store.state.error.error) {
    next()
  } else {
    next({ path: '/' })
  }
}
